export const bieconfig = {

  bieentity: {
    service: {
      name: 'bieentity',
      title: 'BIE Entities',
      key: 'rid',
      num: true,
      fields: [
        'rid','rix',
        'nam','shc','dsc',
        'tyi','tyc','tyn',
        'uni','unc','unn',
        'ssi','ssc','ssn',
        'dcd','exi','sts','ast','stp'
      ],
      params: {
        nam: 'Name',
        shc: 'Code',
        tyi: 'Type',
        uni: 'Unit',
        sts: 'Status'
      },
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['tyn','Type'],
        ['unn','Unit'],
        ['sts','Status'],
        ['stp','Stamp']
      ],
      bar: { pag: true, btn: ['add','edit','del','view'] },
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'Code', v: 'shc' },
          { t: 'Type', v: 'tyn' },
          { t: 'Unit', v: 'unn' }
        ],
        def: 'nam'
      },
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'tyi', label: 'Entity Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'bieentitytype' } },
        { id: 'uni', label: 'Unit', type: 'fa', req: 1, ops: {}, cp: { t: 'bcs', s: 'bieunit' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {}, off: ['add'] },
        { id: 'sts', label: 'Status', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'status' } }
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  bieentry: {
    service: {
      name: 'bieentry',
      title: 'BIE Entry',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','dsc','gpi','gpc','gpn','tyi','tyc','tyn','uni','unc','unn','ssi','ssc','ssn','cor','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', gpi:'Group', tyi:'Type', uni:'Unit', sts:'Status' },
      grid: [['scn','Scenario'],['nam','Name'],['shc','Code'],['pdn','Period'],['tyn','Type'],['unn','Unit'],['sts','Status']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Group',v:'gpn'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'gpi',label:'Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biegroup'}},
        {id:'tyi',label:'Flow Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieflowtype'}},
        {id:'uni',label:'Unit',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieunit'}},
        {id:'cor',label:'Calculation Order',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:false,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  bielocation: {
    service: {
      name: 'bielocation',
      title: 'BIE Locations',
      key: 'rid',
      num: true,
      fields: [
        'rid','rix',
        'nam','shc','dsc',
        'tyi','tyc','tyn',
        'ssi','ssc','ssn',
        'dcd','exi','sts','ast','stp'
      ],
      params: {
        nam: 'Name',
        shc: 'Code',
        tyi: 'Type',
        sts: 'Status'
      },
      grid: [
        ['nam','Name'],
        ['shc','Code'],
        ['tyn','Type'],
        ['sts','Status'],
        ['stp','Stamp']
      ],
      bar: { pag: true, btn: ['add','edit','del','view'] },
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'Code', v: 'shc' },
          { t: 'Type', v: 'tyn' }
        ],
        def: 'nam'
      },
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'tyi', label: 'Location Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bie', s: 'bielocationtype' } },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {}, off: ['add'] },
        { id: 'sts', label: 'Status', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'status' } }
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  bieperiod: {
    service: {
      name: 'bieperiod',
      title: 'BIE Periods',
      key: 'rid',
      num: true,
      fields: [
        'rid','rix',
        'nam','shc','dsc',
        'tyi','tyc','tyn',
        'ssi','ssc','ssn',
        'sdt','edt','sro',
        'dcd','exi','sts','ast','stp'
      ],
      params: {
        nam: 'Name',
        shc: 'Code',
        tyi: 'Type',
        sts: 'Status'
      },
      grid: [
        ['sro','Order'],
        ['nam','Name'],
        ['shc','Code'],
        ['tyn','Type'],
        ['sdt','Start Date'],
        ['edt','End Date'],
        ['sts','Status'],
        ['stp','Stamp']
      ],
      bar: { pag: true, btn: ['add','edit','del','view'] },
      menu: {
        mnu: [
          { t: 'Name', v: 'nam' },
          { t: 'Code', v: 'shc' },
          { t: 'Type', v: 'tyn' }
        ],
        def: 'nam'
      },
      eform: [
        { id: 'nam', label: 'Name', type: 'tf', req: 1, ops: {} },
        { id: 'shc', label: 'Code', type: 'tf', req: 1, ops: {} },
        { id: 'dsc', label: 'Description', type: 'ta', req: 0, ops: {} },
        { id: 'tyi', label: 'Period Type', type: 'fa', req: 1, ops: {}, cp: { t: 'bie', s: 'bieperiodtype' } },
        { id: 'sdt', label: 'Start Date', type: 'df', req: 0, ops: {} },
        { id: 'edt', label: 'End Date', type: 'df', req: 0, ops: {} },
        { id: 'sro', label: 'Sort Order', type: 'nf', req: 1, ops: {} },
        { id: 'exi', label: 'Extra Info', type: 'jf', req: 0, ops: {}, off: ['add'] },
        { id: 'sts', label: 'Status', type: 'fa', req: 1, ops: {}, cp: { t: 'lcs', s: 'status' } }
      ],
    },
    create: true,
    actions: { add: 'Add', edit: 'Edit', del: 'Delete', delete: 'Delete', view: 'View' },
    panels: { add: 'simple', edit: 'simple', delete: 'dialog', view: 'simple' }
  },

  ////// ADMIn CONFIGS

  biescenario: {
    service: {
      name: 'biescenario',
      title: 'BIE Scenarios',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','dsc','tyi','tyc','tyn','ssi','ssc','ssn','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', tyi:'Type', sts:'Status' },
      grid: [['nam','Name'],['shc','Code'],['tyn','Type'],['sts','Status'],['stp','Stamp']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Type',v:'tyn'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'tyi',label:'Scenario Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biescenariotype'}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  biegroup: {
    service: {
      name: 'biegroup',
      title: 'BIE Groups',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','dsc','ssi','ssc','ssn','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', sts:'Status' },
      grid: [['nam','Name'],['shc','Code'],['sts','Status'],['stp','Stamp']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  bieflow: {
    service: {
      name: 'bieflow',
      title: 'BIE Flows',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','dsc','gpi','gpc','gpn','tyi','tyc','tyn','uni','unc','unn','ssi','ssc','ssn','cor','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', gpi:'Group', tyi:'Type', uni:'Unit', sts:'Status' },
      grid: [['cor','Order'],['nam','Name'],['shc','Code'],['gpn','Group'],['tyn','Type'],['unn','Unit'],['sts','Status']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Group',v:'gpn'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'gpi',label:'Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biegroup'}},
        {id:'tyi',label:'Flow Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieflowtype'}},
        {id:'uni',label:'Unit',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieunit'}},
        {id:'cor',label:'Calculation Order',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  // bieentry: {
  //   service: {
  //     name: 'bieentry',
  //     title: 'BIE Entry',
  //     key: 'rid',
  //     num: true,
  //     fields: ['rid','rix','nam','shc','dsc','gpi','gpc','gpn','tyi','tyc','tyn','uni','unc','unn','ssi','ssc','ssn','cor','dcd','exi','sts','ast','stp'],
  //     params: { nam:'Name', shc:'Code', gpi:'Group', tyi:'Type', uni:'Unit', sts:'Status' },
  //     grid: [['scn','Scenario'],['nam','Name'],['shc','Code'],['pdn','Period'],['tyn','Type'],['unn','Unit'],['sts','Status']],
  //     bar: { pag:true, btn:['add','edit','del','view'] },
  //     menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Group',v:'gpn'}], def:'nam' },
  //     eform: [
  //       {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
  //       {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
  //       {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
  //       {id:'gpi',label:'Group',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biegroup'}},
  //       {id:'tyi',label:'Flow Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieflowtype'}},
  //       {id:'uni',label:'Unit',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieunit'}},
  //       {id:'cor',label:'Calculation Order',type:'nf',req:1,ops:{}},
  //       {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
  //       {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
  //     ],
  //   },
  //   create:false,
  //   actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
  //   panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  // },

  biedriver: {
    service: {
      name: 'biedriver',
      title: 'BIE Drivers',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','dsc','fli','flc','fln','tyi','tyc','tyn','uni','unc','unn','dfv','mnv','mxv','snw','iad','irq','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', fli:'Flow', tyi:'Type', uni:'Unit', iad:'Adjustable', sts:'Status' },
      grid: [['nam','Name'],['shc','Code'],['fln','Flow'],['tyn','Type'],['unn','Unit'],['dfv','Default'],['iad','Adjustable'],['sts','Status']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Flow',v:'fln'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'dsc',label:'Description',type:'ta',req:0,ops:{}},
        {id:'fli',label:'Flow',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'bieflow'}},
        {id:'tyi',label:'Driver Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biedrivertype'}},
        {id:'uni',label:'Unit',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieunit'}},
        {id:'dfv',label:'Default Value',type:'nf',req:0,ops:{}},
        {id:'mnv',label:'Minimum Value',type:'nf',req:0,ops:{}},
        {id:'mxv',label:'Maximum Value',type:'nf',req:0,ops:{}},
        {id:'snw',label:'Sensitivity Weight',type:'nf',req:1,ops:{}},
        {id:'iad',label:'Adjustable',type:'ch',req:1,ops:{},values:[1,0]},
        {id:'irq',label:'Required',type:'ch',req:1,ops:{},values:[1,0]},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:0,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  bieformula: {
    service: {
      name: 'bieformula',
      title: 'BIE Formulas',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','exp','fli','flc','fln','dri','drc','drn','sci','scc','scn','cor','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', fli:'Flow', dri:'Driver', sci:'Scope', sts:'Status' },
      grid: [['cor','Order'],['nam','Name'],['shc','Code'],['fln','Flow'],['drn','Driver'],['scn','Scope'],['sts','Status']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Flow',v:'fln'},{t:'Driver',v:'drn'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'exp',label:'Expression',type:'ta',req:1,ops:{}},
        {id:'fli',label:'Flow',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'bieflow'}},
        {id:'dri',label:'Driver',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'biedriver'}},
        {id:'sci',label:'Formula Scope',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieformulascope'}},
        {id:'cor',label:'Calculation Order',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  biedependency: {
    service: {
      name: 'biedependency',
      title: 'BIE Dependencies',
      key: 'rid',
      num: true,
      fields: ['rid','rix','pdi','pdc','pdn','cdi','cdc','cdn','tyi','tyc','tyn','ssi','ssc','ssn','cof','dcd','exi','sts','ast','stp'],
      params: { pdi:'Parent Driver', cdi:'Child Driver', tyi:'Relationship Type', ssi:'State', sts:'Status' },
      grid: [
        ['pdn','Parent Driver'],
        ['cdn','Child Driver'],
        ['tyn','Relationship Type'],
        ['cof','Coefficient'],
        ['ssn','State'],
        ['sts','Status'],
        ['stp','Stamp']
      ],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Parent Driver',v:'pdn'},{t:'Child Driver',v:'cdn'},{t:'Relationship Type',v:'tyn'},{t:'State',v:'ssn'}], def:'pdn' },
      eform: [
        {id:'pdi',label:'Parent Driver',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieparentdriver'}},
        {id:'cdi',label:'Child Driver',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biechilddriver'}},
        {id:'tyi',label:'Relationship Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bierelationshiptype'}},
        {id:'cof',label:'Coefficient',type:'nf',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  bieobjective: {
    service: {
      name: 'bieobjective',
      title: 'BIE Objectives',
      key: 'rid',
      num: true,
      fields: ['rid','rix','nam','shc','sci','scc','scn','tyi','tyc','tyn','rti','rtc','rtn','fli','flc','fln','dri','drc','drn','uni','unc','unn','tgv','tlv','dcd','exi','sts','ast','stp'],
      params: { nam:'Name', shc:'Code', sci:'Scenario', tyi:'Type', fli:'Flow', dri:'Driver', sts:'Status' },
      grid: [['nam','Name'],['shc','Code'],['scn','Scenario'],['tyn','Type'],['tgv','Target'],['tlv','Tolerance'],['sts','Status']],
      bar: { pag:true, btn:['add','edit','del','view'] },
      menu: { mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Scenario',v:'scn'}], def:'nam' },
      eform: [
        {id:'nam',label:'Name',type:'tf',req:1,ops:{}},
        {id:'shc',label:'Code',type:'tf',req:1,ops:{}},
        {id:'sci',label:'Scenario',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biescenario'}},
        {id:'tyi',label:'Objective Type',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieobjectivetype'}},
        {id:'rti',label:'Result Type',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'bieresulttype'}},
        {id:'fli',label:'Flow',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'bieflow'}},
        {id:'dri',label:'Driver',type:'fa',req:0,ops:{},cp:{t:'bcs',s:'biedriver'}},
        {id:'uni',label:'Unit',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'bieunit'}},
        {id:'tgv',label:'Target Value',type:'nf',req:1,ops:{}},
        {id:'tlv',label:'Tolerance Value',type:'nf',req:1,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},
        {id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}
      ],
    },
    create:true,
    actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'},
    panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'}
  },

  // SYSCOHADA
  biesyscohada: {
    service: {
      name: 'biesyscohada',
      title: 'SYSCOHADA Statement',
      key: 'lineid',
      num: true,
      fields: ['lineid','linecode','linename','isderived','sortorder','basevalue','resultvalue','expressions'],
      params: { scc: 'Scenario', pdc: 'Period' },
      grid: [
        ['sortorder','Order'],
        ['linecode','Code'],
        ['linename','Line'],
        ['basevalue','Base Value'],
        ['resultvalue','Result Value'],
        ['isderived','Derived']
      ],
      bar: { pag: false, btn: ['view'] },
      menu: { mnu: [{ t: 'Code', v: 'linecode' }, { t: 'Line', v: 'linename' }], def: 'linecode' },
      eform: [
        { id:'linecode', label:'Code', type:'rf', req:0, ops:{} },
        { id:'linename', label:'Line', type:'rf', req:0, ops:{} },
        { id:'basevalue', label:'Base Value', type:'rf', req:0, ops:{} },
        { id:'resultvalue', label:'Result Value', type:'rf', req:0, ops:{} },
        { id:'expressions', label:'Expression', type:'rf', req:0, ops:{} }
      ],
    },
    create:false,
    actions:{view:'View'},
    panels:{view:'simple'}
  },

  // REONCILIATION
  bieimporthistory: {
    service: {
      name: 'bieimport',
      title: 'BIE Import History',
      key: 'rid',
      num: true,
      fields: ['rid','rix','tri','soc','son','scc','scn','nam','shc','fnm','trc','vrc','wrc','frc','crc','amt','vam','fam','pct','dcd','exi','sts','ast','stp'],
      params: { soc:'Source', sts:'Status' },
      grid: [
        ['dcd','Date'], ['soc','Source'], ['scc','Scenario'], ['fnm','File'],
        ['trc','Rows'], ['vrc','Valid'], ['wrc','Warning'], ['frc','Failed'],
        ['crc','Committed'], ['amt','Amount'], ['pct','Commit %']
      ],
      bar: { pag:true, btn:['view','errors','summary'] },
      menu: { mnu:[{t:'Source',v:'soc'},{t:'Scenario',v:'scc'},{t:'File',v:'fnm'}], def:'soc' },
      eform: [
        {id:'tri',label:'Track ID',type:'rf',req:0,ops:{}},
        {id:'soc',label:'Source',type:'rf',req:0,ops:{}},
        {id:'scc',label:'Scenario',type:'rf',req:0,ops:{}},
        {id:'fnm',label:'Filename',type:'rf',req:0,ops:{}},
        {id:'trc',label:'Rows',type:'rf',req:0,ops:{}},
        {id:'vrc',label:'Valid',type:'rf',req:0,ops:{}},
        {id:'wrc',label:'Warning',type:'rf',req:0,ops:{}},
        {id:'frc',label:'Failed',type:'rf',req:0,ops:{}},
        {id:'crc',label:'Committed',type:'rf',req:0,ops:{}},
        {id:'amt',label:'Amount',type:'rf',req:0,ops:{}},
        {id:'exi',label:'Extra Info',type:'jf',req:0,ops:{}}
      ],
    },
    create:false,
    actions:{view:'View',errors:'Errors',summary:'Summary'},
    panels:{view:'simple',errors:'custom',summary:'custom'}
  },

  bieimporterrors: {
    service: {
      name: 'bieimport',
      title: 'BIE Import Errors',
      key: 'rid',
      num: true,
      fields: ['rid','imi','tri','lno','scc','pdc','enc','lcc','acc','drc','ref','qty','upr','amt','erc','erm','raw','dcd','exi','sts','ast','stp'],
      params: { rid:'Import ID' },
      grid: [
        ['lno','Row'], ['scc','Scenario'], ['pdc','Period'], ['enc','Entity'],
        ['lcc','Location'], ['acc','Account'], ['drc','Driver'], ['ref','Reference'],
        ['erc','Code'], ['erm','Message']
      ],
      bar: { pag:true, btn:['view'] },
      menu: { mnu:[{t:'Reference',v:'ref'},{t:'Error Code',v:'erc'},{t:'Message',v:'erm'}], def:'ref' },
      eform: [
        {id:'lno',label:'Row',type:'rf',req:0,ops:{}},
        {id:'ref',label:'Reference',type:'rf',req:0,ops:{}},
        {id:'erc',label:'Error Code',type:'rf',req:0,ops:{}},
        {id:'erm',label:'Message',type:'ta',req:0,ops:{}},
        {id:'raw',label:'Raw Data',type:'jf',req:0,ops:{}}
      ],
    },
    create:false,
    actions:{view:'View'},
    panels:{view:'simple'}
  },

  //EXECUTIVE
  bieexecutive: {
    service: {
      name: 'bieexecutive',
      title: 'BIE Executive Workbench',
      key: 'metriccode',
      num: false,
      fields: ['metriccode','metricname','metricgroup','basevalue','targetvalue','variancevalue','variancepercent'],
      params: { bsc:'Base Scenario', tsc:'Target Scenario' },
      grid: [
        ['metricgroup','Group'],
        ['metricname','Metric'],
        ['basevalue','Base'],
        ['targetvalue','Target'],
        ['variancevalue','Variance'],
        ['variancepercent','Variance %']
      ],
      bar: { pag:false, btn:['compare','waterfall','tornado','snapshot'] },
      menu: { mnu:[{t:'Metric',v:'metricname'},{t:'Group',v:'metricgroup'}], def:'metricname' },
      eform: [
        {id:'metricname',label:'Metric',type:'rf',req:0,ops:{}},
        {id:'basevalue',label:'Base Value',type:'rf',req:0,ops:{}},
        {id:'targetvalue',label:'Target Value',type:'rf',req:0,ops:{}},
        {id:'variancevalue',label:'Variance',type:'rf',req:0,ops:{}},
        {id:'variancepercent',label:'Variance %',type:'rf',req:0,ops:{}}
      ],
    },
    create:false,
    actions:{compare:'Compare',waterfall:'Waterfall',tornado:'Tornado',snapshot:'Snapshot',view:'View'},
    panels:{compare:'custom',waterfall:'custom',tornado:'custom',snapshot:'dialog',view:'simple'}
  },

  // BIE CAPACITY
  biecapacitypolicy: { service: { name:'biecapacitypolicy', title:'BIE Capacity Policies', key:'rid', num:true, fields:['rid','rix','sci','scc','scn','nam','shc','dsc','rvp','dsv','srv','rgr','eff','eft','exi','sts','ast','stp'], params:{sci:'Scenario',nam:'Name',shc:'Code',sts:'Status'}, grid:[['scn','Scenario'],['nam','Name'],['shc','Code'],['rvp','Reserve %'],['dsv','Debt Service'],['srv','Strategic Reserve'],['rgr','Regulatory Reserve'],['sts','Status']], bar:{pag:true,btn:['add','edit','del','view']}, menu:{mnu:[{t:'Name',v:'nam'},{t:'Code',v:'shc'},{t:'Scenario',v:'scn'}],def:'nam'}, eform:[{id:'sci',label:'Scenario',type:'fa',req:1,ops:{},cp:{t:'bcs',s:'biescenario'}},{id:'nam',label:'Name',type:'tf',req:1,ops:{}},{id:'shc',label:'Code',type:'tf',req:1,ops:{}},{id:'dsc',label:'Description',type:'ta',req:0,ops:{}},{id:'rvp',label:'Reserve %',type:'nf',req:1,ops:{}},{id:'dsv',label:'Debt Service',type:'nf',req:0,ops:{}},{id:'srv',label:'Strategic Reserve',type:'nf',req:0,ops:{}},{id:'rgr',label:'Regulatory Reserve',type:'nf',req:0,ops:{}},{id:'eff',label:'Effective From',type:'df',req:0,ops:{}},{id:'eft',label:'Effective To',type:'df',req:0,ops:{}},{id:'exi',label:'Extra Info',type:'jf',req:0,ops:{},off:['add']},{id:'sts',label:'Status',type:'fa',req:1,ops:{},cp:{t:'lcs',s:'status'}}] }, create:true, actions:{add:'Add',edit:'Edit',del:'Delete',delete:'Delete',view:'View'}, panels:{add:'simple',edit:'simple',delete:'dialog',view:'simple'} },

  // BIE FORECAST
  bieforecastdatamart: {
    service: { name:'bieforecastdatamart', title:'BIE Forecast Data Mart', key:'id', num:false, fields:[], params:{}, grid:[], bar:{pag:false,btn:[]}, menu:{mnu:[],def:''}, eform:[] },
    create:false,
    actions:{view:'View'},
    panels:{view:'custom'},
    custom:{ component:'BieForecastDataMartWorkbench', mode:'fullpage', routing:'menu-component' },
  },


};

export default bieconfig;
